<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <rect
      x="6.54297"
      y="0.923828"
      width="8"
      height="8"
      rx="4"
      transform="rotate(45 6.54297 0.923828)"
      fill="white"
    />
    <rect
      x="6.54297"
      y="-1.19719"
      width="11"
      height="11"
      rx="5.5"
      transform="rotate(45 6.54297 -1.19719)"
      stroke="white"
    />
  </svg>
</template>